import { jwtDecode }  from 'jwt-decode';

export const setLocalStorage = (token, expiresIn) => {
    localStorage.setItem('jwt', token);
    localStorage.setItem('jwtExpiry', getFutureTimestamp(expiresIn));
};

export const getStoredToken = () => localStorage.getItem('jwt');

export const getTokenExpiry = () => {
    const expiry = localStorage.getItem('jwtExpiry');
    return expiry ? parseInt(expiry, 10) : NaN;
};

export const isTokenExpired = () => {
    const expiry = getTokenExpiry();
    return isNaN(expiry) || Date.now() >= expiry;
};

export const getUser = () => {
    const token = getStoredToken();
    if (!token) return {};

    try {
        const { user_id, user_email } = jwtDecode(token);
        return { id: user_id, email: user_email };
    } catch (err) {
        console.error('Invalid JWT:', err);
        return {};
    }
};

export const clearStorage = () => {
    localStorage.removeItem('jwt');
    localStorage.removeItem('jwtExpiry');
};

const getFutureTimestamp = (expiresInSeconds) => {
    return (Date.now() + expiresInSeconds * 1000).toString();
};

const TERMS_BANNER_KEY = 'termsBannerDismissed';

export const dismissTermsBanner = () => {
  localStorage.setItem(TERMS_BANNER_KEY, 'true');
};

export const isTermsBannerDismissed = () => {
  return localStorage.getItem(TERMS_BANNER_KEY) === 'true';
};

// Changelog version tracking
const CHANGELOG_VERSION_KEY = 'changelogLastSeenVersion';
const CURRENT_CHANGELOG_VERSION = '0.9.9'; // Update this when changelog changes

export const setChangelogSeen = (version = CURRENT_CHANGELOG_VERSION) => {
  localStorage.setItem(CHANGELOG_VERSION_KEY, version);
};

export const shouldShowChangelog = () => {
  const lastSeenVersion = localStorage.getItem(CHANGELOG_VERSION_KEY);
  return lastSeenVersion !== CURRENT_CHANGELOG_VERSION;
};

export const getCurrentChangelogVersion = () => {
  return CURRENT_CHANGELOG_VERSION;
};
